export default "/images/lobby6.png";